import styled, { css } from 'styled-components';

const Container = styled.div`
  margin: ${({ theme, isDesktop }) => (isDesktop ? 0 : theme.spacing(10))};
  position: absolute;
  z-index: ${({ theme }) => theme.commons.tooltip.zIndex};
  right: 0;
  ${({ isDesktop }) =>
    isDesktop
      ? css`
          top: 40px;
          left: -7px;
          width: 160px;
        `
      : css`
          top: 30px;
        `}
`;

export default Container;
